<template>
  <div>
    <v-form ref="formRef" @submit.prevent="handleSubmit">
      <div class="mb-5">
        <label for="" class="mb-3">Pilih Jenis Kendaraan</label>
        <div class="row">
          <div class="col-12 col-md-6 mb-3 mb-md-0">
            <div
              :class="jenisKendaraan == 'MOTOR' ? 'card card-active' : 'card'"
              @click="setJenisKendaraan('MOTOR')"
              style="cursor: pointer"
            >
              <div class="card-body py-5">
                <div class="d-flex align-items-center">
                  <img src="@/assets/ill/il-motor.svg" alt="" />
                  <p class="mb-0 ml-3 fz-16 fw-700" style="color: #67747e">
                    Sepeda Motor
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div class="col-12 col-md-6 mb-3 mb-md-0">
            <div
              :class="jenisKendaraan == 'MOBIL' ? 'card card-active' : 'card'"
              @click="setJenisKendaraan('MOBIL')"
              style="cursor: pointer"
            >
              <div class="card-body py-5">
                <div class="d-flex align-items-center">
                  <img src="@/assets/ill/il-car.svg" alt="" />
                  <p class="mb-0 ml-3 fz-16 fw-700" style="color: #67747e">
                    Mobil
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="mb-3">
        <label for="" class="mb-3">Nomor Registrasi (Nopol)</label>
        <v-text-field
          placeholder="Masukkan nomor polisi"
          v-model="no_pol"
          dense
          filled
          solo
          class="input-primary"
          :rules="[
            (value) => {
              return genericRequiredRule(value, 'Nomor Polisi');
            },
          ]"
        ></v-text-field>
      </div>
      <div class="mb-5">
        <label for="" class="mb-3">Nomor Rangka Kendaraan (optional)</label>
        <v-text-field
          placeholder="4 digit terkakhir nomor rangka"
          v-model="no_rangka"
          dense
          filled
          solo
          class="input-primary"
          required
        ></v-text-field>
      </div>
      <div class="row justify-content-end">
        <div class="col-12 col-md-6 col-lg-3">
          <v-btn type="submit" class="btn btn-primary w-100">Lanjut</v-btn>
        </div>
      </div>
    </v-form>
    <v-dialog
      v-model="dialogAlasan"
      @click:outside="handleModalAlasan()"
      persistent
      width="100%"
      max-width="400"
    >
      <ModalAlasan />
    </v-dialog>
  </div>
</template>

<script>
import { FieldRequired } from "@/mixins/ValidationRules";
import Swal from "sweetalert2";

export default {
  name: "DataKendaraan",
  mixins: [FieldRequired],
  components: {
    ModalAlasan: () => import("@/components/molecules/ModalAlasan"),
  },
  data() {
    return {
      dialogAlasan: false,
      token: localStorage.getItem("token"),
      jenisKendaraan: "",
    };
  },
  computed: {
    jenis: {
      get() {
        return this.$store.state.main.form.jenisKendaraan;
      },
      set(value) {
        this.$store.commit("SET_FORM_MAIN", {
          key: "jeniskendaraan",
          value: value,
        });
      },
    },
    no_pol: {
      get() {
        return this.$store.state.main.form.no_pol;
      },
      set(value) {
        this.$store.commit("SET_FORM_MAIN", {
          key: "no_pol",
          value: value,
        });
      },
    },
    no_rangka: {
      get() {
        return this.$store.state.main.form.no_rangka;
      },
      set(value) {
        this.$store.commit("SET_FORM_MAIN", {
          key: "no_rangka",
          value: value,
        });
      },
    },
  },
  watch: {
    jenis: function (val) {
      this.jenisKendaraan = val;
    },
  },
  methods: {
    handleModalAlasan() {
      this.dialogAlasan = !this.dialogAlasan;
    },
    setJenisKendaraan(value) {
      this.jenisKendaraan = value;
      this.jenis = value;
    },
    handleSubmit() {
      if (this.token) {
        if (!this.jenisKendaraan) {
          Swal.fire({
            title: "Oppss..",
            text: "Silahkan pilih jenis kendaraan",
            icon: "error",
            confirmButtonText: "Ok",
          });
          return;
        }
        if (this.$refs.formRef.validate()) {
          this.$store.dispatch("InformationPajakKendaraanBermotor");
        }
      } else {
        this.handleModalAlasan();
      }
    },
  },
  created() {
    this.jenisKendaraan = this.jenis;
  },
};
</script>
